import { TypeOfWork } from '../candidate/type-of-work';

export enum SpecialtyCategory {
  Medical = 'medical',
  Dental = 'dental',
}

export interface Specialty {
  id: string;
  name: string;
  category: SpecialtyCategory;
}

export const getSpecialtyCategory = (typesOfWork: TypeOfWork[]): SpecialtyCategory =>
  typesOfWork.includes(TypeOfWork.DentalPractice) ? SpecialtyCategory.Dental : SpecialtyCategory.Medical;

/* eslint-disable eslint-compat/camelcase */
export const SPECIALTY_I18N = {
  family_medicine: 'Allgemeinmedizin',
  anesthesiology: 'Anästhesie',
  pediatrics: 'Pädiatrie',
  obstetrics_and_gynecology: 'Gynäkologie',
  psychiatry: 'Psychiatrie',
  neurology: 'Neurologie',
  orthopedics: 'Orthopädie',
  radiology: 'Radiologie',
  nuclear_medicine: 'Nuklearmedizin',
  dermatology: 'Dermatologie',
  otolaryngology: 'HNO',
  ophthalmology: 'Augenheilkunde',
  geriatrics: 'Geriatrie',
  occupational_medicine: 'Arbeitsmedizin',
  gastroenterology: 'Gastroenterologie',
  cardiology: 'Kardiologie',
  pulmonology: 'Pneumologie',
  nephrology: 'Nephrologie',
  hematology_and_oncology: 'Hämatologie / Onkologie',
  endocrinology: 'Endokrinologie',
  rheumatology: 'Rheumatologie',
  vascular_medicine: 'Angiologie',
  infectious_diseases: 'Infektiologie',
  general_internal_medicine: 'Innere Medizin (ohne Schwerpunkt)',
  general_surgery: 'Allgemeinchirurgie',
  visceral_surgery: 'Viszeralchirurgie',
  trauma_surgery: 'Unfallchirurgie',
  neurosurgery: 'Neurochirurgie',
  thoracic_surgery: 'Thoraxchirurgie',
  cardiac_surgery: 'Herzchirurgie',
  vascular_surgery: 'Gefäßchirurgie',
  plastic_surgery: 'Plastische Chirurgie',
  pediatric_surgery: 'Kinderchirurgie',
  medical_other: 'Sonstiges',
  general_dentistry: 'Allgemeine Zahnheilkunde',
  oral_surgery: 'Oralchirurgie',
  implantology: 'Implantologie',
  mkg: 'MKG',
  orthodontics: 'Kieferorthopädie',
  aesthetic_dentistry: 'Ästhetische Zahnmedizin',
  endodontics: 'Endodontie',
  pediatric_dentistry: 'Kinderzahnmedizin',
  dental_other: 'Sonstiges',
};
